<style lang="less" scoped>
.navbar {
  height: 64px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 0px !important;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  position: relative;
  z-index: 999;
  .hamburger-container {
    transition: all 0.3s, padding 0s;
    padding: 0 24px;
    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }
  .right-menu {
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .username {
      vertical-align: 12px;
      color: #333;
      font-size: 14px;
    }
    .avatar-container {
      margin-right: 30px;
      .avatar-wrapper {
        cursor: pointer;
      }
    }
  }
}
</style>
<style>
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  display: flex;
  flex-direction: column;
  font-size: 20px;
}
</style>

<template>
  <div>
    <div class="navbar">
      <hamburger
        :toggle-click="toggleSideBar"
        :is-active="sidebar.opened"
        class="hamburger-container"
      />

      <div class="right-menu">
        <el-dropdown class="avatar-container right-menu-item" trigger="hover">
          <div class="avatar-wrapper">
            <span class="username right-menu-item">{{ user.name }}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <span style="display: block" @click="changePassword"
                >修改密码</span
              >
            </el-dropdown-item>
            <el-dropdown-item>
              <span
                style="display: block"
                @click="createAppletCodeVisible = true"
                >生成小程序码</span
              >
            </el-dropdown-item>
            <el-dropdown-item divided>
              <span style="display: block" @click="logout">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <el-dialog
      title="生成小程序码"
      :visible.sync="createAppletCodeVisible"
      width="600px"
    >
      <el-form
        :model="createAppletCodeForm"
        label-position="right"
        label-width="90px"
        :rules="createAppletCodeRules"
        ref="createAppletCodeRef"
      >
        <el-form-item label="快捷页面">
          <el-select
            v-model="shortcutPageValue"
            placeholder="请选择"
            style="width: 100%"
            @change="changeHandle"
          >
            <el-option
              v-for="item in shortcutPageOptions"
              :key="item.path"
              :label="item.label"
              :value="item.path"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="页面路径" prop="path">
          <el-input
            v-model="createAppletCodeForm.path"
            placeholder="请输入页面路径，格式如pages/tabbar/index"
          ></el-input>
        </el-form-item>
        <el-form-item label="页面参数" prop="params">
          <el-input
            v-model="createAppletCodeForm.params"
            placeholder="请输入页面参数，格式如id=1&scene=music"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="createMusicSelectMiniCode"
            :disabled="!createAppletCodeForm.path"
            >生成小程序码</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-image :src="codeUrl" style="width: 220px; height: 220px">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
              待生成
            </div>
          </el-image>
        </el-form-item>
        <el-form-item>
          <el-link :disabled="!this.codeUrl" :href="this.codeUrl"
            ><icon
              style="padding-top: 7px"
              name="arrow_downward"
            />下载小程序码</el-link
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="400px">
      <el-form :model="passwordForm">
        <el-form-item label="手机号码" :label-width="formLabelWidth">
          <el-input
            maxlength="11"
            type="phone_number"
            v-model="passwordForm.phoneNumber"
          ></el-input>
        </el-form-item>
        <el-form-item label="当前密码" :label-width="formLabelWidth">
          <el-input
            type="password"
            v-model="passwordForm.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth">
          <el-input
            type="password"
            v-model="passwordForm.newPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码确认" :label-width="formLabelWidth">
          <el-input
            type="password"
            v-model="passwordForm.newPasswordAg"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePassword">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Hamburger from "@/components/Hamburger";
import { getMusicSelectMiniCode } from "@/api/music";

const shortcutPageOptions = [
  {
    path: "pages/tabbar/index",
    params: "id=1&scene=music",
    label: "首页",
  },
];

export default {
  components: {
    Hamburger,
  },
  data: () => ({
    dialogFormVisible: false,
    formLabelWidth: "auto",
    passwordForm: {
      phoneNumber: "",
      password: "",
      newPassword: "",
      newPasswordAg: "",
    },
    createAppletCodeVisible: false,
    shortcutPageValue: "",
    createAppletCodeForm: {
      path: "",
      params: "",
    },
    shortcutPageOptions,
    createAppletCodeRules: {
      path: [{ required: true, message: "路径必填", trigger: "change" }],
    },
    codeUrl: "",
  }),
  watch: {
    createAppletCodeVisible(value) {
      if (value) {
        this.createAppletCodeForm.path = "";
        this.createAppletCodeForm.params = "";
        this.shortcutPageValue = "";
        this.codeUrl = "";
        this.$nextTick(() => {
          this.$refs.createAppletCodeRef.resetFields();
        });
      }
    },
  },
  computed: {
    ...mapState("app", {
      sidebar: (state) => state.sidebar,
      device: (state) => state.device,
    }),
    ...mapState("auth", {
      user: (state) => state.currentUser || {},
    }),
  },
  methods: {
    createMusicSelectMiniCode() {
      this.$refs.createAppletCodeRef.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            text: "生成中...",
          });
          try {
            const url = await getMusicSelectMiniCode({
              path: `${this.createAppletCodeForm.path}${
                this.createAppletCodeForm.params
                  ? "?" + this.createAppletCodeForm.params
                  : ""
              }`,
              tag: "casio-music",
            });
            this.codeUrl = url;
          } finally {
            loading.close();
          }
        } else {
          return false;
        }
      });
    },
    changeHandle(value) {
      const { path, params } = this.shortcutPageOptions.find(
        (item) => item.path == value
      );
      this.createAppletCodeForm.path = path;
      this.createAppletCodeForm.params = params;
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$confirm("确定退出当前账号", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      await this.$store.dispatch("auth/logout");
      this.$router.replace({ name: "login" });
    },
    changePassword() {
      this.dialogFormVisible = true;
    },
    async updatePassword() {
      const { password, newPassword, newPasswordAg, phoneNumber } = this.passwordForm;
      if (!phoneNumber) {
        this.$message.error("请填写手机号码");
        return;
      }
      if (!password || !newPassword) {
        this.$message.error("请填写密码");
        return;
      }
      if (newPassword.length < 6) {
        this.$message.error("请填写6位数及以上的密码");
        return;
      }
      if (newPassword != newPasswordAg) {
        this.$message.error("密码确认不一致");
        return;
      }
      await this.$store.dispatch("auth/update", { password, newPassword, phoneNumber });
      this.$message.success("密码修改成功");
      this.dialogFormVisible = false;
    },
  },
};
</script>
